import axios from "axios";
import {getAuth} from "firebase/auth";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

axiosInstance.interceptors.request.use(
  async config => {
    const auth = getAuth();

    if (auth && auth.currentUser) {
      const token = await auth.currentUser.getIdToken();

      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["Accept"] = "application/json";

    return config;
  },
  error => Promise.reject(error)
);

export const get = (url, params) => axiosInstance.get(url, {params}).then(r => r.data).catch(e => {
  throw e;
});

export const post = (url, data) => axiosInstance.post(url, data).then(r => r.data);

export const put = (url, data) => axiosInstance.put(url, data).then(r => r.data);

export const del = url => axiosInstance.delete(url).then(r => r.data);
